<template>
    <div class="page">
        
       
        <div class="page-content">

            <div class="container" v-if="!erro">
                <center>
                    <div class="hidden-lg hidden-xl hidden-md" style="margin-top: 25vh;"></div>
                    <img src="static/images/logo.png" style="width: 200px; margin-top: 10%;"/>
                </center>
                <h2 style="text-align: center;">
                    <i class="las la-check-circle"></i>
                    Certificado conectado
                </h2>
                <p class="text-align-center">
                    O seu certificado digital foi conectado com sucesso. Agora volte para o aplicativo Osis para usar o certificado.
                </p>
            </div>
            <div class="container" v-if="erro">
                <center>
                    <div class="hidden-lg hidden-xl hidden-md" style="margin-top: 25vh;"></div>
                    <img src="static/images/logo.png" style="width: 200px; margin-top: 10%;"/>
                </center>
                <h2 style="text-align: center;">
                    <i class="las la-times"></i>
                    Erro ao conectar certificado
                </h2>
                <p class="text-align-center">
                    Erro: {{erro}}. Por favor, volte para o aplicativo Osis e tente conectar novamente.
                </p>
            </div>

            <div class="">
                <div class="block">

                    <!-- <button onclick="window.close()" class="link external button-large button button-fill">
                        <i class="las la-times"></i>
                        Fechar
                    </button> -->
                </div>
            </div>
        </div>
        
    </div>     
</template>

<script>
import Toolbar from './Toolbar'
import Top from './Top'
export default {
    name: 'CertificadoResultado',
    components: {
        'Toolbar': Toolbar,
        'Top': Top,
    },          
    data () {
        var self                    = this;
        return {
            erro: false,
            form: {}      
        }
    },
    methods: {
        sair: function() {
            var self = this;
            console.log("sair()");
            // self.$router.push({ 
            //     name:       "Login",
            // }).catch(()=>{});                              
            return false;            
        },      
    }, 
    created: function() {
       var self = this;
       if (self.$route.query.error) {
            self.erro = self.$route.query.error;
            self.$forceUpdate();
        }
    },  
    mounted: function() {
       
        loading.hide();
    }   
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
   
   
</style>



// WEBPACK FOOTER //
// src/components/CertificadoResultado.vue